import app from 'flarum/forum/app';
import { extend } from 'flarum/extend';

import u2diIndexPage from './u2diIndexPage';
import u2diRedirectPage from './u2diRedirectPage';
import addSidebarMenu from './addSidebarMenu';
import addSignUpField from './addSignUpField';
import MapModule from './components/MapModule';
import U2DiInfoBase from './model/U2DiInfoBase';
import U2DiInfoDetails from './model/U2DiInfoDetails';
import U2DiInfoQueries from './model/U2DiInfoQueries';
import U2DiInfoDistributes from './model/U2DiInfoDistributes';
import U2DiInfoReports from './model/U2DiInfoReports';
import U2DiInviteCode from './model/U2DiInviteCode';
import U2DiUserInfo from './model/U2DiUserInfo';
import U2DiPrivateUserInfo from './model/U2DiPrivateUserInfo';
import U2DiAnnouncement from './model/U2DiAnnouncement';
import U2DiStatistic from './model/U2DiStatistic';
import U2DiNotification from './model/U2DiNotification';
import U2DiNotificationSet from './model/U2DiNotificationSet';
import U2DiRequest from './model/U2DiRequest';

export { default as extend } from './extend';

app.initializers.add('ziven-flarum-u2di', () => {
  app.store.models.u2diInfoBase = U2DiInfoBase;
  app.store.models.u2diInfoDetails = U2DiInfoDetails;
  app.store.models.u2diInfoQueries = U2DiInfoQueries;
  app.store.models.u2diInfoDistributes = U2DiInfoDistributes;
  app.store.models.u2diInfoReports = U2DiInfoReports;
  app.store.models.u2diInviteCode = U2DiInviteCode;
  app.store.models.u2diUserPrivateInfo = U2DiPrivateUserInfo;
  app.store.models.u2diUserInfo = U2DiUserInfo;
  app.store.models.u2diUserInfoList = U2DiUserInfo;
  app.store.models.U2DiPrivateUserInfo = U2DiPrivateUserInfo;
  app.store.models.u2diAnnouncementList = U2DiAnnouncement;
  app.store.models.u2diStatistic = U2DiStatistic;
  app.store.models.u2diNotification = U2DiNotification;
  app.store.models.u2diNotificationSet = U2DiNotificationSet;
  app.store.models.u2diRequest = U2DiRequest;

  app.routes['u2di'] = {
    path: '/u2di',
    component: u2diIndexPage,
  };
  
  app.routes['u2diRedirect1'] = {
    path: '/settings',
    component: u2diRedirectPage,
  };
  
  app.routes['u2diRedirect2'] = {
    path: '/all',
    component: u2diRedirectPage,
  };
  
  app.routes['u2diRedirect3'] = {
    path: '/u/:username',
    component: u2diRedirectPage,
  };
  
  app.routes['u2diRedirect4'] = {
    path: '/notifications',
    component: u2diRedirectPage,
  };
  
  app.routes['u2diRedirect5'] = {
    path: '/d/:id',
    component: u2diRedirectPage,
  };
  
  app.routes['u2diRedirect6'] = {
    path: '/u/:username/security',
    component: u2diRedirectPage,
  };
  
  app.routes['u2diRedirect7'] = {
    path: '/tags',
    component: u2diRedirectPage,
  };

  addSidebarMenu();
  addSignUpField();

  console.group('%c U2DI %c 初始化成功 ', 'background-color: #fbbc04; color: #ffffff; font-weight: bold;', 'background-color: green; color: #ffffff; font-weight: bold;');
  // console.log("Contact Info: QQ: 2091714527 | Discord: Ziven#5504 | Telegram: @ziven2022");
  console.groupEnd();
});